import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app.component';
import { isChunkLoadError, recoverApplication } from './app/core/utils/app-recovery.util';

// Register service worker to fix incorrect .mjs MIME type on servers that serve
// ES module files as application/octet-stream (e.g. nginx without explicit mime mapping).
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/mjs-mime-fix.sw.js').catch(console.error);
}

// Initial navigation is 'enabledBlocking', so a stuck startup guard/API renders a white screen.
const STARTUP_TIMEOUT_MS = 30000;
console.info('[CHiME startup] Bootstrapping application');
const startupWatchdog = window.setTimeout(() => {
  // SSO callback is handled by SSOLoginGuard and must keep its PKCE state.
  if (window.location.pathname.startsWith('/sso/login')) {
    return;
  }
  recoverApplication(`Startup did not complete within ${STARTUP_TIMEOUT_MS}ms on ${window.location.pathname}`, undefined, true);
}, STARTUP_TIMEOUT_MS);

bootstrapApplication(App, appConfig)
  .then(() => {
    window.clearTimeout(startupWatchdog);
    console.info('[CHiME startup] Application bootstrapped');
  })
  .catch((err) => {
    window.clearTimeout(startupWatchdog);
    recoverApplication('Application bootstrap failed', err, !isChunkLoadError(err));
  });
